import { createClient } from '@supabase/supabase-js'

const supabaseUrl = "https://mrikhcwgibcpxfalukhk.supabase.co"
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1yaWtoY3dnaWJjcHhmYWx1a2hrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mjg2MzI1MzIsImV4cCI6MjA0NDIwODUzMn0.961EUZc9_GUH7MR-M6fm88i4byvpzn0-1rykrqlPpVU"

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
        flowType: 'pkce',
        autoRefreshToken: true,
        persistSession: true,
    }
})